export enum EntityType {
  UserClient = 1,
  Document = 104,
  WorkflowJob = 204,
  List = 13
}
